<template>
  <el-container direction="vertical">
    <headers v-if="!$route.meta.result"></headers>
    <router-view ></router-view>
  </el-container>
</template>
<script type="text/ecmascript-6">
  import headers from 'src/components/header/HomePageHeader'

  export default {
    components:{
      headers,
    },
    data() {
      return {
      }
    },
    computed: {
      headerShow() {
        let routeName = this.$route.name;
        if(!['result'].indexOf(routeName) !== -1) {
          return true
        }else {
          return false
        }
      }
    }
  };
</script>
<!--<style href=""></style>-->